export const getStatusOptions = (areAllOptionsAvailable) => {
  const initialOptions = [
    { label: '-', value: '-' },
    { label: 'Needs Attention', value: 'Needs Attention' },
  ];

  if (areAllOptionsAvailable) {
    return [
      ...initialOptions,
      {
        label: 'Satisfactory',
        value: 'Satisfactory',
      },
    ];
  }

  return initialOptions;
};

export const getReasonOptions = (areAllOptionsAvailable) => {
  const baseOptions = [{ label: '-', value: '-' }];
  const otherOptions = [
    {
      label: 'Other (please explain)',
      value: 'Other (please explain)',
    },
  ];
  const satisfactoryReasons = [
    {
      label: 'Completes assignments',
      value: 'Completes assignments',
    },
    {
      label: 'Consistent effort/participation',
      value: 'Consistent effort/participation',
    },
    {
      label: 'Good work quality/comprehension',
      value: 'Good work quality/comprehension',
    },
    {
      label: 'Noticeable improvement',
      value: 'Noticeable improvement',
    },
    {
      label: 'Regular attendance',
      value: 'Regular attendance',
    },
  ];

  const initialUnsatisfactoryReasons = [
    {
      label: 'Excessive absences or stopped attending',
      value: 'Excessive absences or stopped attending',
    },
    {
      label: 'Never attended',
      value: 'Never attended',
    },
  ];

  const unsatisfactoryReasons = [
    ...initialUnsatisfactoryReasons,
    {
      label: 'C- or below/at risk to fail (please explain)',
      value: 'C- or below/at risk to fail (please explain)',
    },
    {
      label: 'Missing/Late assignments',
      value: 'Missing/Late assignments',
    },
    {
      label: 'Poor work quality/comprehension/participation',
      value: 'Poor work quality/comprehension/participation',
    },
    {
      label: 'Care referral',
      value: 'Care referral',
    },
    {
      label: 'Financial concern',
      value: 'Financial concern',
    },
    {
      label: 'Technology concern',
      value: 'Technology concern',
    },
  ];

  return {
    '-': [...baseOptions],
    // Excellent is now Satisfactory. Keep this for backward compatibility.
    excellent: [...baseOptions],
    // satisfactory - needs improvement is no longer valid. Keep this for backward compatibility
    'satisfactory - needs improvement': [...baseOptions],
    satisfactory: [...baseOptions, ...satisfactoryReasons],
    // unsatisfactory is now "needs attention"
    'needs attention': [
      ...baseOptions,
      ...(areAllOptionsAvailable
        ? [...unsatisfactoryReasons, ...otherOptions]
        : initialUnsatisfactoryReasons),
    ],
  };
};

export const gradeOptions = [
  { label: '-', value: '-' },
  {
    label: 'A',
    value: 'A',
  },
  {
    label: 'A-',
    value: 'A-',
  },
  {
    label: 'B+',
    value: 'B+',
  },
  {
    label: 'B',
    value: 'B',
  },
  {
    label: 'B-',
    value: 'B-',
  },
  {
    label: 'C+',
    value: 'C+',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'C-',
    value: 'C-',
  },
  {
    label: 'D+',
    value: 'D+',
  },
  {
    label: 'D',
    value: 'D',
  },
  {
    label: 'D-',
    value: 'D-',
  },
  {
    label: 'F',
    value: 'F',
  },
  {
    label: 'P',
    value: 'P',
  },
];

export const cOrAboveGrades = ['A', 'A-', 'B+', 'B-', 'B', 'C+', 'C'];
export const statusesRequireReason = ['Needs Attention'];
export const reasonsRequireComment = [
  'Other (please explain)',
  'C- or below/at risk to fail (please explain)',
];
export const reasonsRequireGrade = ['C- or below/at risk to fail (please explain)'];
